import { Component, Input } from '@angular/core';
import { TableComponent } from '../../../../core/table/table.component';
import { ColumnComponent } from '../../../../core/table/column.component';

@Component({
  selector: 'app-coverage-deductible',
  imports: [TableComponent, ColumnComponent],
  template: `<app-table
    [dataSource]="dataSource"
    [pageSize]="5"
    [scrollable]="false"
    [stripedRows]="false"
    theme="Dark"
    recordLabel="Deductible"
    [globalFilterFields]="['appliesTo', 'amount', 'type', 'comment']"
  >
    <app-column name="appliesTo" label="Applies To" width="20%" />
    <app-column name="amount" label="Amount" width="20%" format="c" />
    <app-column name="type" label="Type" width="20%" />
    <app-column name="comment" label="Comment" width="40%" />
  </app-table>`,
  styles: [],
})
export class CoverageDeductibleComponent {
  @Input() dataSource: any;
}
